import { AppUser } from '../models/Users';
import useAppSelector from './useAppSelector';

const useAppUser = (): Partial<AppUser> => {
  return useAppSelector((state) => state.user.appUser) || {};
};

export default useAppUser;
